import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';

var MLoggerLevel;
(function (MLoggerLevel) {
    /**
     * Show all logs
     */
    MLoggerLevel[MLoggerLevel["ALL"] = 0] = "ALL";
    MLoggerLevel[MLoggerLevel["TRACE"] = 1] = "TRACE";
    MLoggerLevel[MLoggerLevel["DEBUG"] = 2] = "DEBUG";
    MLoggerLevel[MLoggerLevel["INFO"] = 3] = "INFO";
    MLoggerLevel[MLoggerLevel["LOG"] = 4] = "LOG";
    MLoggerLevel[MLoggerLevel["WARN"] = 5] = "WARN";
    MLoggerLevel[MLoggerLevel["ERROR"] = 6] = "ERROR";
    /**
     * Don't show any log
     */
    MLoggerLevel[MLoggerLevel["NONE"] = 99] = "NONE";
})(MLoggerLevel || (MLoggerLevel = {}));
var MLoggerColor;
(function (MLoggerColor) {
    MLoggerColor["DEFAULT"] = "background: #0F803E; color: white";
    MLoggerColor["TRACE"] = "background: #C55302; color: white";
    MLoggerColor["DEBUG"] = "background: #0066FF; color: white";
    MLoggerColor["INFO"] = "background: #0F803E; color: white";
    MLoggerColor["LOG"] = "background: #0F803E; color: white";
    MLoggerColor["WARN"] = "background: #FD832A; color: white";
    MLoggerColor["ERROR"] = "background: #E9001F; color: white";
})(MLoggerColor || (MLoggerColor = {}));

const M_LOGGER_CONFIG = new InjectionToken('M_LOGGER_CONFIG');
const DEFAULT_LOGGER_CONFIG = {
    logLevel: MLoggerLevel.INFO
};

/* eslint-disable no-console */
class MLoggerService {
    constructor(config) {
        this.config = config;
        this.title = 'MERCADONA';
        this.init();
    }
    noop() { }
    init() {
        this.bindTrace();
        this.bindDebug();
        this.bindInfo();
        this.bindLog();
        this.bindWarn();
        this.bindError();
    }
    bindTrace() {
        this.trace =
            MLoggerLevel.TRACE >= this.config.logLevel
                ? console.trace.bind(window.console, `%c ${this.title} `, MLoggerColor.TRACE)
                : this.noop;
    }
    bindDebug() {
        this.debug =
            MLoggerLevel.DEBUG >= this.config.logLevel
                ? console.debug.bind(window.console, `%c ${this.title} `, MLoggerColor.DEBUG)
                : this.noop;
    }
    bindInfo() {
        this.info =
            MLoggerLevel.INFO >= this.config.logLevel
                ? console.info.bind(window.console, `%c ${this.title} `, MLoggerColor.INFO)
                : this.noop;
    }
    bindLog() {
        this.log =
            MLoggerLevel.LOG >= this.config.logLevel
                ? console.log.bind(window.console, `%c ${this.title} `, MLoggerColor.LOG)
                : this.noop;
    }
    bindWarn() {
        this.warn =
            MLoggerLevel.WARN >= this.config.logLevel
                ? console.warn.bind(window.console, `%c ${this.title} `, MLoggerColor.WARN)
                : this.noop;
    }
    bindError() {
        this.error =
            MLoggerLevel.ERROR >= this.config.logLevel
                ? console.error.bind(window.console, `%c ${this.title} `, MLoggerColor.ERROR)
                : this.noop;
    }
}
MLoggerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerService, deps: [{ token: M_LOGGER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
MLoggerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [M_LOGGER_CONFIG]
                }] }]; } });

/**
 * Module to use de MLoggerService.
 *
 * Default config:
 * ```typescript
 * {
 *    logLevel: MLoggerLevel.INFO
 * }
 * ```
 *
 */
class MLoggerModule {
    /**
     * Use only on the root module
     *
     * @param {MLoggerConfig} config The logger configuration
     * @returns {ModuleWithProviders<MLoggerModule>} The module with providers
     */
    static forRoot(config) {
        return {
            ngModule: MLoggerModule,
            providers: [
                MLoggerService,
                {
                    provide: M_LOGGER_CONFIG,
                    useValue: {
                        ...DEFAULT_LOGGER_CONFIG,
                        ...config
                    }
                }
            ]
        };
    }
    /**
     * Use only when you want specific config for child modules, otherwise use `forRoot()`
     *
     * @param {MLoggerConfig} config The logger configuration
     * @returns {ModuleWithProviders<MLoggerModule>} The module with providers
     */
    static forChild(config) {
        return {
            ngModule: MLoggerModule,
            providers: [
                MLoggerService,
                {
                    provide: M_LOGGER_CONFIG,
                    useValue: {
                        ...DEFAULT_LOGGER_CONFIG,
                        ...config
                    }
                }
            ]
        };
    }
}
MLoggerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MLoggerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: MLoggerModule });
MLoggerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MLoggerModule, decorators: [{
            type: NgModule
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_LOGGER_CONFIG, MLoggerColor, MLoggerLevel, MLoggerModule, MLoggerService, M_LOGGER_CONFIG };
